import { callApi } from "./index"

export const getConciergeInfo = (): Promise<IAssignedConcierge> => {
  return callApi('/api/dashboardapi/user-concierge-preference', { })
}

export const _getConciergeInfo = (): Promise<IAssignedConcierge> => {
  return fetch('/api/dashboardapi/user-concierge-preference').then(res => res.json())
}

export const _updateConciergeInfo = (data: UpdateConciergePreferences): Promise<{channelUrl: string}> => {
  return fetch('/api/easydirectoryapi/update-concierge-preference', {
    method: 'POST',
    body: JSON.stringify(data),
  }).then(res => res.json())
}

export interface IAssignedConcierge {
    IsUserPreferenceSelected?: boolean;
    StaffId?: number;
    ChannelUrl?: string;
    StaffFirstName?: string;
    StaffProfileImage?: string;
    IsOnline?: boolean;
}

export type UpdateConciergePreferences = {
  noOfGuests?: string;
  budget?: string;
  phone: string;
} & (
  | { venue: boolean; packages?: false; destinationWeddings?: false; other?: false }
  | { packages: boolean; venue?: false; destinationWeddings?: false; other?: false }
  | { destinationWeddings: boolean; venue?: false; packages?: false; other?: false }
  | { other: boolean; venue?: false; packages?: false; destinationWeddings?: false }
)